import { render, staticRenderFns } from "./zxclcx.vue?vue&type=template&id=59108432&scoped=true"
import script from "./zxclcx.vue?vue&type=script&lang=js"
export * from "./zxclcx.vue?vue&type=script&lang=js"
import style0 from "./zxclcx.vue?vue&type=style&index=0&id=59108432&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59108432",
  null
  
)

export default component.exports